'use strict';

var eclipseApp = angular.module(moduleConfig.applicationModuleName, moduleConfig.applicationModuleVendorDependencies);
eclipseApp.brtControllers = [];
eclipseApp.brtEndpoints = {};
angular.module(moduleConfig.applicationModuleName).constant('moment', moment);